// extracted by mini-css-extract-plugin
export default {"loaderIcon":"LoaderIcon_loaderIcon__lR1-N","spinning":"LoaderIcon_spinning__vrXKI"};